import React, { FC, useCallback } from 'react'

import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { DELETED_FOLDER } from '@/features/FileManager/FileManager'
import { clearFiles, setActiveModal } from '@/features/FileManager/fileManagerSlice'
import { useDeleteUserDocumentMutation, useUpdateUserDocumentMutation } from '@/services/documents'

export const FileDeleteModal: FC = () => {
  const dispatch = useAppDispatch()

  const file = useAppSelector((state) => state.fileManager.activeModal.file)

  const selectedFiles = useAppSelector((state) => state.fileManager.selectedFiles)

  const [deleteDoc] = useDeleteUserDocumentMutation()
  const [updateDoc] = useUpdateUserDocumentMutation()

  const close = useCallback(() => dispatch(setActiveModal(null)), [dispatch])

  const handleDelete = useCallback(async () => {
    selectedFiles.forEach((file) => {
      if (file.tag === DELETED_FOLDER) {
        deleteDoc(file?.uuid)
      } else {
        updateDoc({ uuid: file.uuid, tag: DELETED_FOLDER })
      }
    })
    dispatch(clearFiles())
    close()
  }, [close, file, deleteDoc, updateDoc, selectedFiles, dispatch])

  return (
    <>
      <p>
        Are you sure you want to {file?.tag === DELETED_FOLDER && <b>permanently</b>} delete{' '}
        {`${selectedFiles.length} file(s)`}?
      </p>
      {selectedFiles.some((it) => it.tag === DELETED_FOLDER) && (
        <p className='text-error mt-1'>
          Files in <b>Deleted</b> folder will be removed permanently
        </p>
      )}
      <div className='flex items-center justify-end w-full mt-2 gap-3'>
        <button
          className='btn'
          type='button'
          onClick={() => close()}
        >
          No
        </button>
        <button
          className='btn btn-primary'
          onClick={handleDelete}
          type='button'
        >
          Yes
        </button>
      </div>
    </>
  )
}
